<template>
  <div>
    <!-- Top banner -->
    <div class="banner" v-bind:style="{ backgroundImage: 'url(' + acf.acf.member_banner + ')' }">
        <h1 class="majorHeading container">{{acf.acf.member_text_first_line}} <br> {{acf.acf.member_text_second_line}} <br> {{acf.acf.member_text_third_line}}</h1>
    </div>
    <!-- This is where pros are made -->
    <div class="pad extraPad">
        <b-container>
            <b-row>
                <b-col lg="6" sm="12">
                    <div>
                        <h1 class="headingleft">{{acf.acf.heading_one}}</h1>
                        <p v-html="acf.acf.paragraph_one"></p>
                    </div>
                    <div class="padSecTwo" >
                        <h1 class="heading">{{acf.acf.heading_two}}</h1>
                        <p v-html="acf.acf.paragraph_two"></p>
                    </div>
                </b-col>
                <b-col lg="6" sm="12">
                    <!-- <img class="imagePro" :src="acf.acf.image_first_section"> -->
                    <h1 class="headingleft">{{acf.acf.success_heading}}</h1>
                    <p v-html="acf.acf.success_storys_block"></p>
                </b-col>
            </b-row>
        </b-container>
    </div>
    <!-- Long Blue Banner -->
    <div class="blueBanner">
        <b-container>
            <h1 class="BannerText">{{acf.acf.banner_text}}</h1>
        </b-container>
    </div>
    <!-- Differnet Memberships -->
    <div class="pad extraPad">
        <b-container>
            <b-row>
                <b-col v-for="(mem, index) in acf.acf.right_block_first_section" :key="'thirtysevendex' +index" lg="3" sm="12">
                    <!-- <img class="imagePro" :src="acf.acf.image_first_section"> -->
                    <div >
                        <b-row>
                            <!-- <b-col lg="2" sm="12">
                                <img class="RightBlockImage" :src="mem.right_block_image">
                            </b-col> -->
                            <b-col lg="12" sm="12" class="ExtraPad">
                                <h1 class="headingFirst heading2" :class="{heading2 : mem.right_block_title.includes('TIER 2'),heading3 : mem.right_block_title.includes('Amateur League')}">{{mem.right_block_title}}</h1>
                                <p v-html="mem.right_block_text"></p>
                            </b-col>
                        </b-row>
                    </div>
                </b-col>
            </b-row>   
        </b-container>
    </div>
    <!-- Tour Membership -->
    <!-- Who Can Join? -->
    <div class="pad extraPad backColorWho">
        <b-container>
            <h1 class="wcj-header">Who Can Join ?</h1>
            <b-row>
                <b-col v-for="(mem, index) in acf.acf.who_can_join" :key="'thirtyeightdex' +index" lg="6" sm="12">
                    <!-- <img class="imagePro" :src="acf.acf.image_first_section"> -->
                    <div>
                        <b-row>
                            <b-col lg="2" sm="12">
                                <img class="whocanjoinimage" :src="mem.who_can_join_image">
                            </b-col>
                            <b-col lg="10" sm="12">
                                <h1 class="headingWho">{{mem.who_can_join_title}}</h1>
                                <p v-html="mem.who_can_join_text"></p>
                            </b-col>
                        </b-row>
                    </div>
                </b-col>
            </b-row>   
        </b-container>
    </div>
    <MembershipBanner/>
  </div>

</template>

<script>
import axios from 'axios'
import MembershipBanner from "@/components/membershipBanner.vue";
export default {
  name: 'Membership Page',
  components: {
    MembershipBanner
  },
  data: function() {
    return {
      acf: [],
      acfMessage:''
    };
  },
  methods: {
    isMobile() {
        if( screen.width <= 500 ) {
            return true;
        }
        else {
            return false;
        }
    },
  },
  mounted() {
    axios //add API Call
        .get(
            'https://wp-cpt.ocs-software.com/' + "/wp-json/wp/v2/pages/983"
        ) // Page number changed on each page based on JSON page id you are calling
        .then((response) => (
            this.acf = response.data
        )); //API data wanted pulled out
  },
}
</script>

<style scoped>
    .RightBlockImage {
        width: 87px;
        height: 87px;   
    }
    .whocanjoinimage {
        width: 87px;
        height: 87px;   
    }
    .padSecTwo {
        padding-top: 22px;
    }
    .padSecTwo > h1 {
        padding-bottom: 36px!important;
    }
    .wcj-header {
        color: #081C3F;
        font-size: 36px;
        /* font-weight: bold; */
        padding-bottom: 50px;
        font-family: "brown-pro-condensed", sans-serif;
        font-weight: 800;
        font-style: normal;
        text-align: center;
    }
    .headingleft {
        color: #081C3F;
        font-size: 36px;
        /* font-weight: bold; */
        padding-bottom: 22px;
        font-family: "brown-pro-condensed", sans-serif;
        font-weight: 800;
        font-style: normal;
    }
    .headingFirst {
        color: #081C3F;
        font-size: 36px;
        /* font-weight: bold; */
        padding-bottom: 22px;
        font-family: "brown-pro-condensed", sans-serif;
        font-weight: 800;
        font-style: normal;
    }
    .headingSuccess {
        color: #081C3F;
        font-size: 28px;
        /* font-weight: bold; */
        padding-bottom: 22px;
        font-family: "brown-pro-condensed", sans-serif;
        font-weight: 800;
        font-style: normal;
        text-decoration: underline;
    }
    .backColorWho {
        background-color: #f9f9f9;
    }
    h1.headingFirst.heading2 {
        padding-bottom: 22px;
        padding-top: 16px;
    }
    h1.headingFirst.heading3 {
        padding-bottom: 22px;
        padding-top: 16px;
    }
    .majorHeading {
        color: #FFFFFF;
        font-size: 65px;
        /* font-weight: bold; */
        font-family: "brown-pro-condensed", sans-serif;
        font-weight: 800;
        font-style: normal;
        position: relative;
        top: 200px;
    }
    .BannerText {
        font-size: 45px;
        font-weight: bold;
        color: #fff;
        text-align: center;
        padding-top: 50px;
        padding-bottom: 50px;
    }
    .spaceUp {
        padding-top: 70px;
    }
    .imagePro {
        width: 572px;
        height: 717px;
        margin: auto;
        display: block;
    }
    .banner {
        width: 100%;
        height: 712px;
        background-repeat: no-repeat;
        background-size: cover;
    }
    .blueBanner {
        background-color: #081C3F;
        color: #fff;
        padding-top: 30px;
        padding-bottom: 30px;
    }
    h1.heading {
        color: #081C3F;
        font-size: 36px;
        /* font-weight: bold; */
        padding-bottom: 50px;
        font-family: "brown-pro-condensed", sans-serif;
        font-weight: 800;
        font-style: normal;
    }
    .headingWho {
        color: #081C3F;
        font-size: 36px;
        /* font-weight: bold; */
        padding-bottom: 20px;
        padding-top: 20px;
        font-family: "brown-pro-condensed", sans-serif;
        font-weight: 800;
        font-style: normal;  
    }
    p {
        font-size: 18px;
        color: #081C3F;
    }
    .pad {
        padding-top: 30px;
        padding-bottom: 30px;
    }
    @media only screen and (max-width: 1366px) {
        .banner {
            height: 512px;
        }
        .majorHeading {
            color: #FFFFFF;
            font-size: 65px;
            font-weight: bold;
            position: relative;
            top: 120px;
        }
    }
    @media only screen and (min-width: 1280px) {
        .ExtraPad {
            padding-left: 30px;
        }
    }
    @media only screen and (max-width: 1199px) {
        .majorHeading {
            display: none;
        }
        .imagePro {
            width: 100%;
            height: auto;
            margin: auto;
            display: block;
        }
    }
    @media only screen and (min-width: 900px) {
        .pad.extraPad {
            padding-top: 100px;
            padding-bottom: 100px;
        }
    }
    @media only screen and (max-width: 510px) {
        .banner {
            width: 100%;
            height: 160px;
            background-repeat: no-repeat;
            background-size: cover;
        }
        h1.heading {
            padding-top: 20px;
            color: #081C3F;
            font-size: 36px;
            /* font-weight: bold; */
            padding-bottom: 30px;
            font-family: "brown-pro-condensed", sans-serif;
            font-weight: 800;
            font-style: normal;
        }
        .spaceUp {
            padding-top: 0;
        }
    }
</style>
